import { Link } from "@tanstack/react-router";
import { SPONSOR } from "@/lib/site";

/**
 * Labelled sponsor unit. Rendered sitewide in the footer and once at the
 * foot of every article. Deliberately visually distinct from navigation so
 * it reads as a disclosure, not as editorial content.
 */
export function SponsorBlock({ variant = "footer" }: { variant?: "footer" | "article" }) {
  const isArticle = variant === "article";

  return (
    <aside
      aria-label={`Sponsored by ${SPONSOR.name}`}
      className={
        isArticle
          ? "mt-16 border-y border-border bg-paper-soft px-5 py-6 sm:px-8"
          : "mt-10 border-t border-border pt-8"
      }
    >
      <p className="eyebrow">Sponsored</p>
      <p className="mt-2 text-base sm:text-lg">
        <span className="text-muted-foreground">Map Observer is funded by </span>
        <a
          href={SPONSOR.url}
          rel={SPONSOR.rel}
          className="font-medium text-ochre-deep underline underline-offset-4 hover:text-accent"
        >
          {SPONSOR.name}
        </a>
        <span className="text-muted-foreground"> — {SPONSOR.tagline}.</span>
      </p>
      <p className="mt-2 text-xs text-muted-foreground">
        {SPONSOR.name} funds this newsroom and has no say in what we cover.{" "}
        <Link to="/sponsors/gbply" className="underline hover:text-accent">
          About {SPONSOR.name}
        </Link>
        {" · "}
        <Link to="/ownership-and-funding" className="underline hover:text-accent">
          Ownership &amp; funding
        </Link>
      </p>
    </aside>
  );
}
